import { PdpCatalogFulfillmentType, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useShippingProductTypeService = () => {
  const params = useCatalogProductIdParams();
  const {
    product: { preorder, fulfillment_type, shipping_fee },
  } = usePdpBaseInfo(params);

  return {
    isDigitalProduct: !shipping_fee,
    isPreorder: Boolean(preorder),
    isGeneralProduct: fulfillment_type === PdpCatalogFulfillmentType.MERCHANT,
    isZigzinProduct: fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN,
    isStoreZigzin: fulfillment_type === PdpCatalogFulfillmentType.VENDOR_FLEX,
  };
};
